import React, { useState, useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { clientSession, idClienteFinal } from '../../utilities/odoo-config';
import { FormatMoney } from '../../utilities/formats';
import { ButtonImagePay } from '../../shared/components/buttons';
import { LoadingMovilGo } from '../../shared/components/loadingMovilGo';
import { PayCardScreen } from './components/card';
import { jsPdfGenerator } from '../../shared/components/pdfTransaction';
import { PseScreen } from './components/pse';
import { payMenRefacil } from '../../services/pay.service';
import { Desencrypt } from '../../utilities/cipher';

// Assets
import pse from '../../assets/pagos/pse.png';
import card from '../../assets/pagos/card.png';

const imageOptions = [
    { name: 'pse', source: pse },
    { name: 'card', source: card }
];

const styles = {
    containerButton: {
        width: 300,
        marginVertical: '1%',
        flexDirection: "column",
        top: '10%',
        left: 0,
        bottom: 0,
        right: 0,
        margin: 'auto'
    },
    containerButtonGroup: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        marginTop: '20px'
    }
};

export const PagosExternosScreen = (props) => {
    // Estados necesarios para UI
    const [buttonsPay, setButtonsPay] = useState([]);
    const [showPse, setShowPse] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userlogin, setUserLogin] = useState({});

    const navigateNext = async (flag, response) => {
        if (!flag && response) {
            const datos = props.datos;
            const precio = parseInt(datos.precio);
            const productPayload = {
                atributes: {
                    valorPagar: parseInt(datos.precio),
                    numeroBoleta: datos.numBoleta,
                    nombre_cliente: `${datos.identificacion} - ${datos.nombre}`.replace(/%20/g, ' ')
                }
            };

            let data = [];
            if (precio > productPayload.atributes.valorPagar) {
                data = [
                    `Factura No: ${response.valida.id}`,
                    `Fecha: ${response.valida.fecha}`,
                    `No.Aprobacion: ${response.valida.numero_aprobacion}`,
                    `Producto: Abono ${datos.nameRifa.replace(/%20/g, ' ')}`,
                    `Resolucion: ${datos.resolucion}`,
                    `Fecha del sorteo: ${datos.sorteo}`,
                    `Número de boleta: ${productPayload.atributes.numeroBoleta}`,
                    `Cliente: ${productPayload.atributes.nombre_cliente}`,
                    `Valor total: ${FormatMoney(precio)}`,
                    `Valor abonado: ${FormatMoney(productPayload.atributes.valorPagar)}`,
                    `Valor por pagar: ${FormatMoney(precio - productPayload.atributes.valorPagar)}`,
                ];
            } else {
                data = [
                    `Factura No: ${response.valida.id}`,
                    `Fecha: ${response.valida.fecha}`,
                    `No.Aprobacion: ${response.valida.numero_aprobacion}`,
                    `Producto: ${datos.nameRifa.replace(/%20/g, ' ')}`,
                    `Resolucion: ${datos.resolucion}`,
                    `Fecha del sorteo: ${datos.sorteo}`,
                    `Número de boleta: ${productPayload.atributes.numeroBoleta}`,
                    `Cliente: ${productPayload.atributes.nombre_cliente}`,
                    `Valor: ${FormatMoney(productPayload.atributes.valorPagar)}`
                ];
            }
            jsPdfGenerator(data);
        } else {
            props.navigate('/');
        }
    };

    const pressImage = async (routePay) => {
        if (props?.datos?.operador_efectivo === 'refacil' && routePay !== 'card') {
            setLoading(true);
            const user = Desencrypt();

            // Obtener IP del cliente
            let ipCliente = "IP_NO_DISPONIBLE";
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                ipCliente = data.ip;
            } catch (error) {
                console.error("Error al obtener IP:", error);
            }

            // Datos directos de props (sin estados intermedios)
            const datos = props.datos;
            const data = {
                product: {
                    atributes: {
                        numeroBoleta: datos.numBoleta,
                        partner_id: parseInt(datos.partner_id),
                        nombre_cliente: `${datos.identificacion} - ${datos.nombre}`.replace(/%20/g, ' '),
                        valorPagar: parseInt(datos.precio),
                        ipCliente: ipCliente
                    },
                    clienteexterno_user_id: parseInt(user.id),
                    product_id: parseInt(JSON.stringify(datos.product_id).replace('?', '').replace(/"/g, ''))
                },
                phone: datos.telefono,
                emailAddress: datos.correo,
                fullName: `${datos.nombre} ${datos.apellido}`,
                dniNumber: datos.identificacion
            };

            console.log("Datos enviados a payMenRefacil:", data);
            
            payMenRefacil(data, userlogin, async (flag, res) => {
                setLoading(false);
                if (flag) {
                    if (res?.error) {
                        const userConfirmed = window.confirm(`${res.error}, debe recargar la página e iniciar de nuevo`);
                        if (userConfirmed) window.location.reload();
                    } else if (res?.url_pago) {
                        window.location.href = res.url_pago;
                    } else {
                        console.error('URL de pago no encontrada');
                    }
                } else {
                    console.error('Error en payMenRefacil:', res);
                }
            });
        } else {
            if (routePay === 'pse') setShowPse(true);
            if (routePay === 'card') setShowCard(true);
        }
    };

    useEffect(() => {
        if (props.datos) {
            console.log('Datos recibidos:', props.datos);
            
            // Inicializar botones
            const buttons = imageOptions.map((option, index) => (
                <div key={`pay-option-${index}`} style={styles.containerButton}>
                    <ButtonImagePay 
                        onClick={() => pressImage(option.name)} 
                        image={option.source} 
                    />
                </div>
            ));
            setButtonsPay(buttons);
            
            // Configurar credenciales
            setUserLogin({
                user: clientSession.user,
                password: clientSession.password
            });
        }
    }, [props.datos]);

    return (
        <div className="col justify-content-center" style={{ alignSelf: 'center', width: '100%', height: 250 }}>
            <Row className="justify-content-center">
                <div className="text-container">
                    <h2 className="defaultTitle">Tus Opciones de Pago</h2>
                    <h6>Tenemos varias formas de pago para facilitarte la compra.</h6>
                </div>
            </Row>

            <Col md={12} xs={12} sm={12} lg={12}>
                <div style={styles.containerButtonGroup}>
                    {buttonsPay}
                </div>
            </Col>

            <div style={{ height: 200, marginTop: '1%' }}></div>

            {loading && <LoadingMovilGo />}

            {showPse && (
                <PseScreen
                    userLogin={userlogin}
                    visible={showPse}
                    product={{
                        product_id: parseInt(props.datos?.product_id?.replace('?', '')),
                        clienteexterno_user_id: idClienteFinal,
                        atributes: {
                            numeroBoleta: props.datos?.numBoleta,
                            valorPagar: parseInt(props.datos?.precio),
                            partner_id: props.datos?.partner_id,
                            nombre_cliente: `${props.datos?.identificacion} - ${props.datos?.nombre}`.replace(/%20/g, ' ')
                        }
                    }}
                    closeModal={(flag) => setShowPse(flag)}
                />
            )}

            {showCard && (
                <PayCardScreen
                    userLogin={userlogin}
                    visible={showCard}
                    product={{
                        product_id: parseInt(props.datos?.product_id?.replace('?', '')),
                        clienteexterno_user_id: idClienteFinal,
                        atributes: {
                            numeroBoleta: props.datos?.numBoleta,
                            valorPagar: parseInt(props.datos?.precio),
                            partner_id: props.datos?.partner_id,
                            nombre_cliente: `${props.datos?.identificacion} - ${props.datos?.nombre}`.replace(/%20/g, ' ')
                        }
                    }}
                    closeModal={(flag, data) => {
                        setShowCard(flag);
                        if (data) {
                            navigateNext(flag, data);
                            window.close();
                        }
                    }}
                />
            )}
        </div>
    );
};